import React from "react";

import { QuestionCircleOutlined } from "@ant-design/icons";
import { Icon } from "@iconify/react";
import { Button, Popconfirm, Space, Tooltip } from "antd";
import { toast } from "utils/toast";

import { useDeleteProperty } from "hooks/useDeleteProperty";

import { ActionSelect } from "js/components/Properties/types";

const PropertyActionSelect: React.FC<ActionSelect> = ({
  property,
  setIsPropertyModalOpen,
  setPropertyId,
}) => {
  const deleteMutation = useDeleteProperty();

  const handleDeleteProperty = (propertyId: string) => {
    if (!propertyId) {
      toast.error("No se pudo eliminar: ID de inmueble inválido.");
      return;
    }
    deleteMutation.mutate(propertyId, {
      onSuccess: () => {
        toast.success("Inmueble eliminado correctamente");
      },
      onError: () => {
        toast.error("No se pudo eliminar el inmueble.");
      },
    });
  };

  return (
    <>
      <Space wrap>
        <Tooltip title="Actualizar información de Inmueble" placement="top">
          <Button
            size={"small"}
            type={"link"}
            onClick={(e) => {
              e.stopPropagation();
              if (!property.id) {
                toast.error("No se pudo editar: ID de inmueble inválido.");
                return;
              }
              setIsPropertyModalOpen(true);
              setPropertyId(property.id);
            }}
          >
            <Icon fontSize={20} icon="akar-icons:edit" />
          </Button>
        </Tooltip>
        <Tooltip title="Eliminar Inmueble" placement="bottom">
          <Popconfirm
            title="Eliminar"
            description="¿Seguro que deseas eliminar?"
            onConfirm={(e) => {
              if (!property.id) {
                toast.error("No se pudo eliminar: ID de inmueble inválido.");
                return;
              }
              handleDeleteProperty(property.id);
              e?.stopPropagation();
            }}
            onCancel={(e) => e?.stopPropagation()}
            icon={
              <QuestionCircleOutlined
                style={{ color: "red" }}
                rev={undefined}
              />
            }
            okText={"Ok"}
            cancelText={"Cancelar"}
          >
            <Button
              danger
              size={"small"}
              type={"link"}
              onClick={(e) => e.stopPropagation()}
            >
              <Icon fontSize={20} icon="bi:trash3" />
            </Button>
          </Popconfirm>
        </Tooltip>
      </Space>
    </>
  );
};
export default PropertyActionSelect;
